import { useState, useEffect, Component, version } from "react";
import NumberPad from "../Components/NumberPad";
import TextField from "../Components/TextField";
import COLORS from "../Colors";
import ButtonContainer from "../Components/ButtonContainer";
import HeightButtons from "../Components/HeightButtons";
import PageNumber from "../Components/PageNumber";
import moment, { lang } from "moment";
import "../Styles/Questionnaire.css";
import { v4 as uuidv4 } from "uuid";
import * as questionnaireData from "../Scripts/QuestionnaireData";
import * as api from "../Scripts/Api";
import * as Constants from "../Utilities/Constants";
import { exportToRedCap } from "../Scripts/ExportToRedcap";
import firebase from "../Utilities/Firebase";
import {LanguageText} from "../Utilities/LanguageText";


var db = firebase.database();

let Q = Constants.PT_QUESTION_NAMES;

const QUESTION_ORDER = [
  // Q_NAMES.FIRST_NAME,
  // Q_NAMES.LAST_NAME,
  // Q_NAMES.BIRTHDAY,
  // Q_NAMES.SEX,
  Q.AGE,
  Q.EDUCATION_LEVEL,
  Q.SELF_CONCERN,
  Q.OTHER_CONCERN,
  Q.HEIGHT,
  Q.WEIGHT,
  Q.DIABETES,
  Q.STROKE,
  Q.HELP,
  Q.ANTIDEPRESSANTS,
  Q.EFFORT,
];

const PROTECTED = [
  //Q_NAMES.FIRST_NAME,
  //Q_NAMES.LAST_NAME,
];
let prefLang = ""; // sessionStorage.getItem("preferredLanguage");
let langIndex = -1; // prefLang === "ES" ? 1 : 0;

let months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

const fullMonths = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];
let days = [...Array(31).keys()];
let youngestAge = 18;
let oldestAge = 100;
let years = [...Array(oldestAge - youngestAge).keys()];

export default class Questionnaire extends Component {
  constructor(props) {
    console.log(`=== ${(new Date()).toLocaleTimeString()} Questionnaire constructor ===`)
    console.log("=== Questionnaire constructor ===")

    langIndex = prefLang === "ES" ? 1 : 0;

    let starting_question = 0;
    let index = Number(sessionStorage.getItem("questionnaireIdx"));
    if (index && index <= QUESTION_ORDER.length - 1 && index > 0) {
      //sets the questionnaire to be at the last visited question
      starting_question = index;
      let q = QUESTION_ORDER[starting_question];
      console.log(q);

      //Sets user back to beginning if they refresh before data is published to redcap
      if (
        q === Q.FIRST_NAME ||
        q === Q.LAST_NAME ||
        q === Q.BIRTHDAY
      ) {
        starting_question = 0;
      }
    }

    //let assessmentId = sessionStorage.getItem("assessmentId");

    // if (assessmentId === "0" || assessmentId === null) {

    //   let assessmentId = api.get_assessmentId()
    //   console.log("%%%%% Assessment Id from API: ", assessmentId)
    //   sessionStorage.setItem("assessmentId", assessmentId)

    //   // sessionStorage.setItem(
    //   //   "assessmentId",
    //   //   // api.get_assessmentId("1", "2", "4")
    //   //   api.get_assessmentId()
    //   // );
    // }

    //assessmentId = sessionStorage.getItem("assessmentId");



    let startTime = sessionStorage.getItem("startTime");
    if (startTime === null || startTime === 0) {
      sessionStorage.setItem("startTime", new Date().getTime());
    }

    let starting_answers = JSON.parse(sessionStorage.getItem("answers"));

    sessionStorage.setItem("startQuest", new Date().getTime());
    let startQs = sessionStorage.getItem("startQuest");
    console.log("Questionnaire start time: ", startQs);

    super(props);

    prefLang = sessionStorage.getItem("preferredLanguage");
    this.languageText = new LanguageText(prefLang);

    this.educationLevels = [
      { value: 0, text: this.languageText.EducationLevelPrompt},
      { value: 1, text: this.languageText.NoFormalEducation },
      { value: 2, text: this.languageText.PrimaryEducation },
      { value: 3, text: this.languageText.GED },
      { value: 4, text: this.languageText.College },
      { value: 5, text: this.languageText.Bachelor },
      { value: 6, text: this.languageText.Graduate },
    ];

    this.state = {
      prefLang: "",
      text: "",
      first_text: "",
      second_text: "",
      focus: -1,
      question_num: starting_question,
      question_answered: false,
      question_answers: starting_answers,
      error: false,
      error_msg: "",
      birthdate: { day: "", month: "", year: "" },
      monthName: "",
      fullYear: "",
      edLevel: 0,
      edText: "",
    };

  }


  // componentDidMount() {
  //   api.get_assessmentId()
  //   .then(assessmentId => sessionStorage.setItem("assessmentId", assessmentId))
  //   console.log("component mounted, set assessmentId to: ", sessionStorage.getItem("assessmentId"))
  //   let admin_email = firebase.auth().currentUser.email;

  //   api.upload_assessment_data(assessmentId, 'email', admin_email);

  //   let provider_email = sessionStorage.getItem('provider_email');
  //   api.upload_assessment_data(assessmentId, 'providerEmail', provider_email);


  // }

  //adds character from numberpad to currently focused field
  add_character = (character) => {
    this.update_textfield(String(this.state.text) + String(character));
  };

  delete_char = () => {
    let len = this.state.text.length;
    if (len >= 1) {
      this.update_textfield(this.state.text.substring(0, len - 1));
    }
  };

  update_textfield = (new_text) => {
    let weight_question = QUESTION_ORDER[this.state.question_num] === Q.WEIGHT;
    let birthday_question =
      QUESTION_ORDER[this.state.question_num] === Q.BIRTHDAY;
    let birthday_text = "MM/DD/YYYY";

    //only allows 3 characters for weight
    if (weight_question) {
      new_text = String(new_text).substring(0, 3);
    }

    //Adds a slash to parts of the birthday question
    console.log("before", new_text);
    if (birthday_question) {
      birthday_text = new_text;
      sessionStorage.setItem("birthtext", birthday_text);
    }
    if (QUESTION_ORDER[this.state.question_num] === Q.FIRST_NAME) {
      console.log("FIRST NAME!!!: ", new_text);
      let firstN = new_text;
      sessionStorage.setItem("firstN", firstN);
    }
    if (QUESTION_ORDER[this.state.question_num] === Q.LAST_NAME) {
      console.log("LAST NAME!!!!: ", new_text);
      let lastN = new_text;
      sessionStorage.setItem("lastN", lastN);
    }

    console.log(new_text);

    //the question is considered answered if the text is updated, unless it is for weight
    let answered = weight_question
      ? this.state.question_answered
      : new_text.length > 0;
    let error = !answered && weight_question && new_text.length > 0;
    let error_msg = "";

    if (birthday_question) {
      // check if valid date and within bounds, otherwise set error
      error = !moment(birthday_text, "MM/DD/YYYY", true).isValid();
      error_msg = "Please enter a date in the form MM/DD/YYYY";
      if (!error) {
        let start = moment("01/01/1900", "MM/DD/YYYY");
        let end = moment(new Date().toLocaleDateString(), "MM/DD/YYYY");

        error = !moment(birthday_text, "MM/DD/YYYY").isBetween(start, end);
        error_msg = "Please enter a valid date";
      }
      answered = !error;
    }

    if (QUESTION_ORDER[this.state.question_num] === Q.EDUCATION_LEVEL) {
      console.log('education level changed, currently: ' + this.state.edLevel)
      console.log(new_text);

      let wasAnswered = this.state.edLevel !== 0
      this.setState({
        edLevel: new_text,
        edText: JSON.parse(JSON.stringify(this.educationLevels[new_text])).text,
        answered: wasAnswered
      })
      // this.state.edLevel = new_text;
      // this.state.edText = JSON.parse(JSON.stringify(educationLevels[this.state.edLevel])).text
      // answered = this.state.edLevel != 0;
    }

    this.setState({
      text: new_text,
      first_text: birthday_text,
      question_answered: answered,
      error: error,
      error_msg: error_msg,
    });
  };

  //used if a child component wants to customize when a question can be considered answered
  update_answered = (answered) => {
    this.setState({
      question_answered: answered,
      error: !answered && this.state.text.length > 0,
    });
  };

  //used when the user is setting their height
  set_feet = (new_text) => {
    this.setState({
      first_text: new_text,
      question_answered: true,
    });
  };

  //used when the user is setting their height
  set_inches = (new_text) => {
    this.setState({
      second_text: new_text,
    });
  };

  send_redcap_info = (answers, birthday, firebase_id) => {
    let screeningId = sessionStorage.getItem("screening_id");

    // push to REDCap to store personal information
    let fields = {
      firstname: answers[Q.FIRST_NAME],
      lastname: answers[Q.LAST_NAME],
      birthday: birthday,
      dateadministered: new Date().toLocaleDateString(),
      testid: firebase_id,
      screening_id: "racs_" + screeningId,
    };
    exportToRedCap(fields);
  };

  // Sends firebse AWS and redCAP id connections
  send_firebase_ids = () => {
    let assessmentId = sessionStorage.getItem("assessmentId");
    let redcap_id = uuidv4();

    // CAUTION: save firebase data before editing -
    // real users data may be overwritten!
    db.ref("ids/ " + "rc " + redcap_id.toString()).set("aws " + assessmentId);
    // end caution

    return redcap_id;
  };

  reset_state = (question_num, answers) => {
    this.setState({
      question_answers: answers,
      question_num: question_num,
      question_answered: false,
      text: "",
      first_text: "",
      second_text: "",
    });
  };

  //When the user is advancing to the next question
  update_question = (question) => {
    let curr_q_name = QUESTION_ORDER[this.state.question_num];
    var curr_answer = this.state.text;
    if (curr_q_name === Q.HEIGHT) {
      curr_answer = questionnaireData.calculate_height(
        this.state.first_text,
        this.state.second_text
      );
    } else if (curr_q_name === Q.AGE) {
      curr_answer = this.state.yearsOld

       // console.log('******** input date:', this.state.first_text)
       // var isoDate = new Date(this.state.first_text).toISOString().slice(0, 10);
       // console.log('******** uploading dob:', isoDate)
       // api.record_prompt_response('dob', isoDate);
       // curr_answer = questionnaireData.convertBirthdayToAge(
       //   this.state.first_text
       // );
    // } else if (curr_q_name === Q.BIRTHDAY) {
    //   console.log('******** input date:', this.state.first_text)
    //   var isoDate = new Date(this.state.first_text).toISOString().slice(0, 10);
    //   console.log('******** uploading dob:', isoDate)
    //   api.record_prompt_response('dob', isoDate);
    //   curr_answer = questionnaireData.(
    //     this.state.first_text
    //   );
    }
    // let curr_answer =
    //   curr_q_name === Q_NAMES.HEIGHT
    //     ? questionnaireData.calculate_height(
    //         this.state.first_text,
    //         this.state.second_text
    //       )
    //     : curr_q_name === Q_NAMES.BIRTHDAY
    //     ? questionnaireData.convertBirthdayToAge(this.state.first_text)
    //     : this.state.text;
    let new_answers = this.state.question_answers;
    new_answers[curr_q_name] = curr_answer;

    if (curr_q_name === Q.WEIGHT) {
      console.log("height,weight");
      console.log(
        this.state.question_answers[Q.HEIGHT],
        this.state.question_answers[Q.WEIGHT]
      );
      let new_answers = this.state.question_answers;
      new_answers["BMI"] = questionnaireData.calculateBMI(
        this.state.question_answers[Q.HEIGHT],
        this.state.question_answers[Q.WEIGHT]
      );
    }

    console.log("NEW ANSWERS!!! ");
    console.log(new_answers);



    //Don't send protected answers (first or last name) to backend
    if (!PROTECTED.includes(curr_q_name)) {
      api.record_prompt_response(curr_q_name, curr_answer);
    }

    //if its the birthday question, upload information to redcap
    if (curr_q_name === Q.BIRTHDAY) {
      let firebase_id = this.send_firebase_ids();
      this.send_redcap_info(new_answers, this.state.first_text, firebase_id);
    }

    //skip to the test section if the users
    //answer indicates this is necessary
    //RECOMMENT THIS IN DURING REAL
    // if(question['skip_answer'] && question['skip_answer'].includes(curr_answer)){
    //   this.props.history.push({
    //     pathname: Constants.PATH_NAMES.TEST
    //   })
    // }
    // if (this.state.question_num === 0) {
    //   console.log("question is 0");
    // } else if (this.state.question_num === 1) {
    //   console.log("question is 1");
    // }
    //Check to see whether there are more
    //questions left to answer
    if (this.state.question_num < QUESTION_ORDER.length - 1) {
      sessionStorage.setItem("questionnaireIdx", this.state.question_num + 1);
      if (new_answers[Q.BIRTHDAY]) {
        PROTECTED.forEach((name) => (new_answers[name] = ""));
        sessionStorage.setItem("answers", JSON.stringify(new_answers));
      }
      let new_question_num = this.state.question_num + 1;

      this.reset_state(new_question_num, new_answers);
    } else {
      let pathToPush = Constants.PATH_NAMES.TEST;

      let now = new Date().getTime();
      // console.log("THE TIME AFTER QUESTIONS!!!! ", now);
      let timeSpent = now - sessionStorage.getItem("startQuest");
      // console.log("Questionaire time (ms): ", timeSpent);
      let timeSecondsQuestions = timeSpent / 1000.0;
      console.log("Questionnaire time (s): " + timeSecondsQuestions);
      api.record_prompt_response("QUEST_TIME", timeSecondsQuestions);
      sessionStorage.setItem("answers", JSON.stringify(new_answers));

      // TODO: comment this in for when real patients start taking their exams
      // if(!questionnaireData.riskScoreIndicatesScreening(this.state.question_answers)){
      //   pathToPush = Constants.PATH_NAMES.FINISH
      // }

      this.props.history.push({
        pathname: pathToPush,
      });
    }
  };

  //When the user is wanting to go to the prev question
  prev_question = (question) => {
    let curr_q_name = QUESTION_ORDER[this.state.question_num];
    let prev_q_name = QUESTION_ORDER[this.state.question_num - 1];
    /* let curr_answer = curr_q_name === Q_NAMES.HEIGHT ? questionnaireData.calculate_height(this.state.first_text, this.state.second_text) :
                        curr_q_name === Q_NAMES.BIRTHDAY ? questionnaireData.convertBirthdayToAge(this.state.first_text) : this.state.text */
    console.log("answers BEFORE erase: !!!!!!");
    console.log(this.state.question_answers);
    let new_answers = this.state.question_answers;
    // Deleting prev question answers
    new_answers[prev_q_name] = "";
    console.log("answers AFTER erase: !!!!!!");
    console.log(new_answers);

    //skip to the test section if the users
    //answer indicates this is necessary
    //RECOMMENT THIS IN DURING REAL
    // if(question['skip_answer'] && question['skip_answer'].includes(curr_answer)){
    //   this.props.history.push({
    //     pathname: Constants.PATH_NAMES.TEST
    //   })
    // }
    // if (this.state.question_num === 0) {
    //   console.log("question is 0");
    // } else if (this.state.question_num === 1) {
    //   console.log("question is 1");
    // }
    //Check to see whether there are prev
    //questions
    if (this.state.question_num >= 1) {
      sessionStorage.setItem("questionnaireIdx", this.state.question_num - 1);

      let new_question_num = this.state.question_num - 1;

      this.reset_state(new_question_num, new_answers);
      sessionStorage.setItem("answers", JSON.stringify(new_answers));
    } //else {
    // Do nothing
    // }
  };

  handleChange = (e) => {
    console.log(e.target.value);
    this.update_textfield(e.target.value);
  };

  handleMonth = (e) => {
    this.setState({
      monthName: fullMonths[months.indexOf(e.target.value)],
    });
    console.log("month name: !!!" + fullMonths[months.indexOf(e.target.value)]);
    let monthNumber = months.indexOf(e.target.value) + 1;
    let month =
      String(monthNumber).length < 2 ? "0" + monthNumber : monthNumber;
    let day = this.state.birthdate.day;
    let year = this.state.birthdate.year;
    this.handleFullBirthdate(month, day, year);
  };

  handleDay = (e) => {
    let month = this.state.birthdate.month;
    let dayNumber = e.target.value;
    let day = dayNumber.length < 2 ? "0" + dayNumber : dayNumber;
    let year = this.state.birthdate.year;
    this.handleFullBirthdate(month, day, year);
  };

  handleYear = (e) => {
    let month = this.state.birthdate.month;
    let day = this.state.birthdate.day;
    let year = e.target.value;
    this.handleFullBirthdate(month, day, year);
  };

  handleFullBirthdate = (month, day, year) => {
    this.setState({
      birthdate: {
        month: month,
        day: day,
        year: year,
      },
    });
    this.update_textfield(month + "/" + day + "/" + year);
  };

  handleYearsOld = (e) => {
    this.setState({
      yearsOld: e.target.value,
      question_answered: true
    })
  };

  render() {
    var yes = this.state.text === this.languageText.Yes;
    var unsure = this.state.text === this.languageText.Unsure;

    var male = this.state.text === Constants.MALE;

    const langIndex = sessionStorage.getItem("preferredLanguage") === "ES" ? 1 : 0;

    var questions = {
      [Q.SELF_CONCERN]: [{
        question_text: (
          <p>
            <b>Do you have concerns about your memory?</b>
          </p>
        ),
        confirm_text:
          "Tap here to confirm you " +
          (yes ? "DO" : "do NOT") +
          " have concerns",
        placeholder: "",
        skip_answer: [this.languageText.Yes],
        prev_text: "< Go back",
      },
      {
        question_text: (
          <p>
            <b>¿Le preocupa su memoria?</b>
          </p>
        ),
        confirm_text:
          "Toque aquí para confirmar que " +
          (yes ? "SÍ" : "NO") +
          " tiene inquietudes",
        placeholder: "",
        skip_answer: [this.languageText.Yes],
        prev_text: "< Volver",
      }
    ],
      [Q.OTHER_CONCERN]: [{
        question_text: (
          <p>
            <b>Does someone you know have concerns about your memory?</b>
          </p>
        ),
        confirm_text:
          "Tap here to confirm " +
          (yes ? "someone you know DOES have" : "NO ONE has") +
          " concerns",
        placeholder: "",
        skip_answer: [this.languageText.Yes],
        prev_text: "< Go back",
      },
      {
        question_text: (
          <p>
            <b>¿Alguien que conoce tiene preocupaciones sobre su memoria?</b>
          </p>
        ),
        confirm_text:
          "Toque aquí para confirmar que alguien que conoce " +
          (yes ? this.languageText.Yes : this.languageText.No) +
          " tiene inquietudes sobre usted ",
        placeholder: "",
        skip_answer: [this.languageText.Yes],
        prev_text: "< Volver",
      }
    ],
      [Q.EDUCATION_LEVEL]: [{
        question_text: (
          <p>
            What is your highest <b>education level?</b>
          </p>
        ),
        confirm_text:
          "Tap here to confirm that your education level is: " + this.state.edText,
        placeholder: "",
        prev_text: "< Go back",
      },
      {
        question_text: (
          <p>
            ¿Cuál es su <b>nivel educativo más alto</b>? <br/>Por favor, seleccione su nivel de educación)
          </p>
        ),
        confirm_text:
          "Toque aquí para confirmar que su nivel educativo es: " + this.state.edText,
        placeholder: "",
        prev_text: "< Volver",
      }
    ],
      [Q.AGE]: [{
        question_text: (
          <p>
            What is your <b>age?</b>
          </p>
        ),
        confirm_text:
          "Tap here to confirm that your age is: " + this.state.yearsOld,
        placeholder: "",
        prev_text: "< Go back",
      },
      {
        question_text: (
          <p>
            ¿Cuál es su <b>etad</b>? <br/>(Por favor, seleccione su nivel de educación)
          </p>
        ),
        confirm_text:
          "Toque aquí para confirmar que su etad es: " + this.state.yearsOld,
        placeholder: "",
        prev_text: "< Volver",
      }
    ],
      [Q.HEIGHT]: [{
        question_text: (
          <p>
            What is your <b>approximate height?</b>
          </p>
        ),
        confirm_text:
          "Tap here to confirm you are " +
          this.state.first_text +
          " feet " +
          (this.state.second_text === "" ? 0 : this.state.second_text) +
          " inches tall",
        placeholder: "Feet",
        placeholder2: "Inches",
        prev_text: "< Go back",
      },
      {
        question_text: (
          <p>
            ¿Cuál es su <b>altura aproximada?</b>
          </p>
        ),
        confirm_text:
          "Toque aquí para confirmar su peso es " +
          this.state.first_text +
          " libras " +
          (this.state.second_text === "" ? 0 : this.state.second_text) +
          " inches tall",
        placeholder: "Feet",
        placeholder2: "Inches",
        prev_text: "< Volver",
      }],
      [Q.WEIGHT]: [{
        question_text: (
          <p>
            What is your <b>approximate weight?</b>
          </p>
        ),
        confirm_text:
          "Tap here to confirm you weigh " + this.state.text + " pounds",
        placeholder: "Use the keypad to enter your weight",
        label: "Pounds",
        limits: {
          lower: questionnaireData.getLowerBMI(
            this.state.question_answers["height"]
          ),
          upper: questionnaireData.getUpperBMI(
            this.state.question_answers["height"]
          ),
        },
        error: "Please enter a valid weight",
        prev_text: "< Go back",
      },
      {
        question_text: (
          <p>
            ¿Cuál es su <b>peso aproximado</b>?
          </p>
        ),
        confirm_text:
          "Toque aquí para confirmar su peso es " + this.state.text + " libras",
        placeholder: "use el teclado para ingresar su peso",
        label: "Libras",
        limits: {
          lower: questionnaireData.getLowerBMI(
            this.state.question_answers["height"]
          ),
          upper: questionnaireData.getUpperBMI(
            this.state.question_answers["height"]
          ),
        },
        error: "Please enter a valid weight",
        prev_text: "< Volver",
      }
    ],
      [Q.DIABETES]: [{
        question_text: (
          <p>
            <b>Do you have type 2 diabetes?</b>
          </p>
        ),
        confirm_text: (
          <div>
            Tap here to confirm you {yes ? "DO" : "do NOT"} have <br /> type 2
            diabetes
          </div>
        ),
        placeholder: "",
        prev_text: "< Go back",
      },
      {
        question_text: (
          <p>
            <b>¿Tiene usted diabetes tipo 2?</b>
          </p>
        ),
        confirm_text: (
          <div>
            Toque aquí para confirmar que {yes ? this.languageText.Yes : this.languageText.No} tiene  <br /> diabetes tipo 2
          </div>
        ),
        placeholder: "",
        prev_text: "< Volver",
      }
    ],
      [Q.STROKE]: [{
        question_text: (
          <p>
            <b>Have you ever had a stroke?</b>
          </p>
        ),
        confirm_text:
          "Tap here to confirm you " +
          (yes ? "HAVE" : "have NOT") +
          " had a stroke",
        placeholder: "",
        prev_text: "< Go back",
      },
      {
        question_text: (
          <p>
            <b>¿Alguna vez ha tenido un derrame cerebral (accidente cerebrovascular)?</b>
          </p>
        ),
        confirm_text:
          "Toque aquí para confirmar que " +
          (yes ? "nunca ha tenido" : "ha sufrido") +
          " un accidente cerebrovascular",
        placeholder: "",
        prev_text: "< Volver",
      }
    ],
      [Q.HELP]: [{
        question_text: (
          <p>
            <b>Do you need help from others to manage money or medications?</b>
          </p>
        ),
        confirm_text:
        "Tap here to confirm you " + (yes ? "DO" : "do NOT") + " need help",
        placeholder: "",
        prev_text: "< Go back",
      },
{
        question_text: (
          <p>
            <b>¿Necesita ayuda de otros para administrar el dinero o sus medicamentos?</b>
          </p>
        ),
        confirm_text:
          "Toque aquí para confirmar que " + (yes ? this.languageText.Yes : this.languageText.No) + " necesita ayuda",
        placeholder: "",
        prev_text: "< Volver",
      }
    ],
      [Q.ANTIDEPRESSANTS]: [{
        question_text: (
          <p>
            <b>Do you take antidepressant medication?</b>
          </p>
        ),
        confirm_text:
          "Tap here to confirm you " +
          (yes ? "DO" : unsure ? "are NOT SURE whether you" : "do NOT") +
          " take antidepressants",
        placeholder: "",
        prev_text: "< Go back",
      },
      {
        question_text: (
          <p>
            <b>¿Toma medicación antidepresiva?</b>
          </p>
        ),
        confirm_text:
          "Toque aquí para confirmar que " +
          (yes ? "" : unsure ? " Insegura/o" : "no") +
          " toma antidepresivas ",
        placeholder: "",
        prev_text: "< Volver",
      }
    ],
      [Q.EFFORT]: [{
        question_text: (
          <p>
            <b>
              In the past week, how many days did you feel that
              <br />
              everything was an effort?
            </b>
          </p>
        ),
        confirm_text: "Tap here to confirm: " + this.state.text,
        placeholder: "",
        prev_text: "< Go back",
      },
      {
        question_text: (
          <p>
            <b>
            ¿Durante la semana pasada, cuántos días sintió que  <br /> todo era un esfuerzo?
            </b>
          </p>
        ),
        confirm_text: "Toque aquí para confirmar: " + this.state.text,
        placeholder: "",
        prev_text: "< Volver",
      }
    ],
    };

    var fieldComponent = (
      <TextField
        update_text={this.update_textfield}
        text={
          QUESTION_ORDER[this.state.question_num] === Q.BIRTHDAY
            ? this.state.first_text
            : this.state.text
        }
        placeholder={questions[QUESTION_ORDER[this.state.question_num]][langIndex]["placeholder"]}
        key={this.state.question_num.toString()}
        label={questions[QUESTION_ORDER[this.state.question_num]][langIndex]["label"]}
        limits={questions[QUESTION_ORDER[this.state.question_num]][langIndex]["limits"]}
        readOnly={
          QUESTION_ORDER[this.state.question_num] === Q.WEIGHT ||
          QUESTION_ORDER[this.state.question_num] === Q.BIRTHDAY
            ? true
            : false
        }
        update_answered={this.update_answered}
        error={
          this.state.error
            ? questions[QUESTION_ORDER[this.state.question_num]][langIndex]["error"]
            : ""
        }
        date={questions[QUESTION_ORDER[this.state.question_num]][langIndex]["date"]}
      />
    );

    var feetButtons = (
      <div className="heightSelector">
        <div>
          <p className="heightLabel">Feet</p>
        </div>
        <HeightButtons
          numbers={[2, 3, 4, 5, 6, 7]}
          onClick={this.set_feet}
          color={COLORS.blue}
          key={"feet" + this.state.question_num}
        />
      </div>
    );

    var inchesButtons = (
      <div className="heightSelector">
        <div>
          <p className="heightLabel">Inches</p>
        </div>
        <HeightButtons
          numbers={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]}
          onClick={this.set_inches}
          color={COLORS.blue}
          key={"inches" + this.state.question_num}
        />
      </div>
    );

    var numberComponent = (
      <div className="questionChild1">
        <NumberPad
          add_char={this.add_character}
          update_text={this.update_textfield}
          key={"num" + this.state.question_num.toString()}
          delete_char={
            QUESTION_ORDER[this.state.question_num] === Q.BIRTHDAY
              ? () => this.delete_char()
              : null
          }
        />
      </div>
    );

    var yesNo = (
      <ButtonContainer
        colors={[COLORS.green, COLORS.red]}
        buttonTexts={[this.languageText.Yes, this.languageText.No]}
        onClick={this.update_textfield}
        key={"yesNo" + this.state.question_num.toString()}
        margin="4em"
      />
    );

    var yesNoUnsure = (
      <ButtonContainer
        colors={[COLORS.green, COLORS.red, COLORS.grey]}
        buttonTexts={[this.languageText.Yes, this.languageText.No, this.languageText.Unsure]}
        onClick={this.update_textfield}
        key={"unsure" + this.state.question_num.toString()}
        minWidth="6em"
        maxWidth="43em"
        margin="4em"
      />
    );

    var maleFemale = (
      <ButtonContainer
        colors={[COLORS.green, COLORS.red]}
        buttonTexts={[Constants.MALE, Constants.FEMALE]}
        onClick={this.update_textfield}
        key={"male" + this.state.question_num.toString()}
        margin="4em"
      />
    );

    let educationLevel = (
      <div className="dropdown">
        <select name="selectedEducationLevel" onChange={this.handleChange}>
          {this.educationLevels.map((level) => (
            <option key={level.value} value={level.value}>
              {level.text}
            </option>
          ))}
          ;
        </select>
      </div>
    );

    var options = (
      <ButtonContainer
        colors={[COLORS.green, COLORS.green, COLORS.green, COLORS.green]}
        buttonTexts={[
          this.languageText.LessThanOneDay,
          this.languageText.OneToTwoDays,
          this.languageText.ThreeToFourDays,
          this.languageText.FiveToSevenDays,
        ]}
        onClick={this.update_textfield}
        key={"option" + this.state.question_num.toString()}
      />
    );
    var nextComponent = (
      <ButtonContainer
        colors={[COLORS.blue]}
        buttonTexts={[
          questions[QUESTION_ORDER[this.state.question_num]][langIndex]["confirm_text"],
        ]}
        buttonType="filled"
        onClick={() =>
          this.update_question(questions[QUESTION_ORDER[this.state.question_num]])
        }
        showButton={this.state.question_answered}
        key={"confirm" + this.state.question_num}
        maxWidth="55em"
      />
    );
    var prevComponent = (
      <div className="prevButton">
        <ButtonContainer
          colors={[COLORS.grey]}
          buttonTexts={[
            questions[QUESTION_ORDER[this.state.question_num]][langIndex]["prev_text"],
          ]}
          buttonType="back"
          onClick={() =>
            this.prev_question(questions[QUESTION_ORDER[this.state.question_num]])
          }
          showButton={!this.state.question_answered}
          key={"previous"}
          maxWidth="40em"
        />
      </div>
    );
    let monthOptions = months.map((value) => {
      return <option key={value}>{value}</option>;
    });

    let dayOptions = days.map((value) => {
      return <option key={value + 1}>{value + 1}</option>;
    });

    let end = new Date().getFullYear();

    let yearOptions = years.map((value) => {
      return <option key={end - oldestAge + value}>{end - oldestAge + value}</option>;
    });


    let monthAns =
      this.state.birthdate.month !== "" && this.state.birthdate.month !== "00"
        ? "answered"
        : "";
    let dayAns =
      this.state.birthdate.day !== "" && this.state.birthdate.day !== "Day"
        ? "answered"
        : "";
    let yearAns =
      this.state.birthdate.year !== "" && this.state.birthdate.year !== "Year"
        ? "answered"
        : "";

    var birthdayDropdown = (
      <div className="dropdown">
        <select
          name="ageMM"
          id="ageMM"
          onChange={this.handleMonth}
          className={monthAns}
        >
          <option key="Month"> Month </option>
          {monthOptions}
        </select>
        <select
          name="ageDD"
          id="ageDD"
          onChange={this.handleDay}
          className={dayAns}
        >
          <option key="Day"> Day </option>
          {dayOptions}
        </select>
        <select
          name="ageYYYY"
          id="ageYYYY"
          onChange={this.handleYear}
          className={yearAns}
        >
          <option key="Year"> Year </option>
          {yearOptions}
        </select>
      </div>
    );

    let yearsOldOptions = years.map((value) => {
      return <option key={youngestAge + value}>{youngestAge + value}</option>;
    });

    let yearsOldAns =
      this.state.yearsOld !== "" || (this.state.birthdate.year !== "" && this.state.birthdate.year !== "Year")
        ? "answered"
        : "";

    var ageDropdown = (
      <div className="dropdown">
        <select
          name="ageYearsOld"
          id="ageYearsOld"
          onChange={this.handleYearsOld}
          className={yearsOldAns}
        >
          <option key="Age"> Age </option>
          {yearsOldOptions}
        </select>
      </div>
    );


    var question_components = [
      // fieldComponent,
      // fieldComponent,
      // birthdayDropdown,
      ageDropdown,
      // maleFemale,
      educationLevel,
      yesNo,
      yesNo,
      [feetButtons, inchesButtons],
      fieldComponent,
      yesNo,
      yesNo,
      yesNo,
      yesNoUnsure,
      options,
    ];

    var className = "";
    console.log("Q_ORDER[this.state.question_num]");
    console.log(QUESTION_ORDER[this.state.question_num]);
    if (
      QUESTION_ORDER[this.state.question_num].includes("Name") ||
      QUESTION_ORDER[this.state.question_num] === Q.WEIGHT
    ) {
      console.log();
      className = "large";
    } else {
      className = "large";
    }


    return (
      <div>
        <PageNumber questionnairePage={this.state.question_num + 1} />
        {this.state.ageMM}
        <div className="questionParent">
          <div className="questionChild2">
            <div className={className}>
              {questions[QUESTION_ORDER[this.state.question_num]][langIndex]["question_text"]}
            </div>
            <div className={className}>
              {question_components[this.state.question_num]}
            </div>
          </div>
          {QUESTION_ORDER[this.state.question_num] === Q.WEIGHT
            ? numberComponent
            : null}
        </div>
        <div>{this.state.question_answered ? nextComponent : null}</div>
        <div>{this.state.question_num !== 0 ? prevComponent : null}</div>
      </div>
    );
  }
}